import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app/App";
// Mock service worker
import { ENABLE_MSW } from "./shared/config/msw";
// Redux toolkit
import { Provider } from "react-redux";
import { store } from "./shared/store/store";
// Tanstack query
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./shared/query/queryClient";
// [DEV]/[STAGE]/[LOCAL] label in the tab title
import { withEnvLabel } from "./shared/utils/with-env-label";

document.title = withEnvLabel(document.title, process.env.REACT_APP_ENV_LABEL);

const container = document.getElementById("root") as HTMLElement;

const bootstrap = async () => {
	if (ENABLE_MSW) {
		try {
			const { worker } = await import("./shared/mocks/browser");
			await worker.start({
				onUnhandledRequest: "bypass",
				serviceWorker: {
					url: "/mockServiceWorker.js",
				},
			});
		} catch (error) {
			console.error("[MSW] Failed to start worker:", error);
		}
	}

	ReactDOM.createRoot(container).render(
		<QueryClientProvider client={queryClient}>
			<BrowserRouter>
				<Provider store={store}>
					<App />
				</Provider>
			</BrowserRouter>
		</QueryClientProvider>,
	);
};

bootstrap();

// const { createProxyMiddleware } = require("http-proxy-middleware");

// module.exports = function (app) {
// 	app.use(
// 		"/api",
// 		createProxyMiddleware({
// 			target: "http://51.21.90.227:6001",
// 			changeOrigin: true,

// 			// Применять для WebSocket
// 			ws: true,

// 			// Важно для auth/headers
// 			secure: false,
// 		}),
// 	);
// };
